import GameApi from './GameApi';
import HistoryApi from './HistoryApi';
import UserApi from './UserApi';
import PromoApi from './PromoApi/PromoApi';
import NewYearApi from './NewYearApi';

class Api {
  constructor(baseUrl = '') {
    this.game = new GameApi(baseUrl);
    this.user = new UserApi(baseUrl);
    this.history = new HistoryApi(baseUrl);
    this.promo = new PromoApi(baseUrl);
    this.newYear = new NewYearApi(baseUrl);
  }
}

export default Api;
